module.exports = __webpack_public_path__ + "static/media/square-services-img.0c183c17.svg";